import { createFileRoute, redirect } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="premises" routeLang="en" />;

const TAB_REDIRECTS: Record<string, string> = {
  library: "/en/insights",
  tips: "/en/tips",
  casos: "/en/real-cases",
};

export const Route = createFileRoute("/en/tools/my-premises")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  beforeLoad: ({ search }) => {
    const target = search.tab ? TAB_REDIRECTS[search.tab] : undefined;
    if (target) throw redirect({ href: target, statusCode: 301 });
  },
  head: () => publicToolHead("premises", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
